/** Distinct, high-contrast colours assigned to laps in comparison order. */
export const LAP_COLOURS = [
  '#4aa3ff', // reference blue
  '#ff5c5c', // red
  '#4ade80', // green
  '#fbbf24', // amber
  '#c084fc', // purple
  '#22d3ee', // cyan
  '#fb923c', // orange
  '#f472b6', // pink
];

/** Colour for the lap at a given position in the compared-laps list. */
export function lapColour(index: number): string {
  return LAP_COLOURS[index % LAP_COLOURS.length];
}

/** Stable string key for a lap reference. */
export function lapKey(ref: { sessionId: string; lapNumber: number }): string {
  return `${ref.sessionId}#${ref.lapNumber}`;
}
